import { HttpErrorResponse, HttpEvent, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { HypecastAuthenticationService } from '@app/shared/authentication/services/authentication.service';
import { IHypecastOAuthService } from '@app/shared/authentication/services/ihypecast-oauth.service';
import { __ } from '@app/shared/functions/object.functions';
import { Ticket } from '@app/shared/models/classes/Ticket';
import { ForbiddenService } from '@app/shared/services/forbidden.service';
import { Observable, Subscriber, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { HTTP_DISABLE_AUTHORIZATION } from './http-context';

function handleAuthorization(
  request: HttpRequest<any>,
  next: (request: HttpRequest<any>) => Observable<HttpEvent<any>>,
  injector: Injector,
  forbiddenService: ForbiddenService,
): Observable<HttpEvent<any>> {
  const authenticationService = injector.get(HypecastAuthenticationService);
  const oauthService = injector.get(IHypecastOAuthService);

  return next(request.clone()).pipe(
    catchError((response: HttpErrorResponse) => {
      if (response.status === 401 && request.method.toLowerCase() !== 'options') {
        return new Observable<any>((subscriber: Subscriber<any>) => {
          oauthService.login().then((data: any) => {
            subscriber.next(data);
            subscriber.complete();
          }).catch((error: any) => {
            subscriber.error(error);
          });
        }).pipe(
          mergeMap((accessToken: Ticket) => {
            return next(
              request.clone({
                setHeaders: { Authorization: `Bearer ${authenticationService.getAccessToken()}` }
              })
            );
          }),
          catchError((error: HttpErrorResponse) => {
            switch (error.status) {
              case 400:
              case 401:
              case 403:
                if (__.IsNullOrUndefined(error.error) || __.IsNullOrUndefinedOrEmpty(error.error.error)) {
                  break;
                }
                authenticationService.logout();
                return throwError(() => response);
              default:
                break;
            }
            return throwError(() => response);
          })
        );
      }

      if (response.status === 403) {
        forbiddenService.forbid();
      }

      throw response;
    })
  );
}

export const authorizationInterceptorFn: HttpInterceptorFn = (request, next) => {
  if (request.context.get(HTTP_DISABLE_AUTHORIZATION)) {
    return next(request);
  }
  return handleAuthorization(request, next, inject(Injector), inject(ForbiddenService));
};
